import { AioButtonComponent } from '@aio/ui';
import { Component } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { AuthFooterComponent } from '../footer/auth-footer.component';
import { pickRandomAuthHero } from '../auth-hero.util';
import { AuthHeroPanelComponent } from '../auth-hero-panel/auth-hero-panel.component';
import { AuthService } from '../../../core/services/auth.service';
import { ForgotPasswordRequest } from '../../../core/models/auth.models';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    AioButtonComponent,CommonModule, FormsModule, ReactiveFormsModule, RouterModule, AuthFooterComponent, AuthHeroPanelComponent],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  readonly hero = pickRandomAuthHero();

  forgotPasswordForm: FormGroup;
  submitted = false;
  loading = false;
  errorMessage = '';
  emailSent = false;
  submittedEmail = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private fb: FormBuilder
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get f() {
    return this.forgotPasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.errorMessage = '';

    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this.sendResetEmail(this.forgotPasswordForm.value.email);
  }

  onTryAgain(): void {
    if (this.submittedEmail) {
      this.sendResetEmail(this.submittedEmail);
    }
  }

  onBackToLogin(): void {
    this.router.navigate(['/login']);
  }

  private sendResetEmail(email: string): void {
    this.loading = true;
    const request: ForgotPasswordRequest = { email };

    this.authService.generateResetToken(request).subscribe({
      next: (response) => {
        this.loading = false;
        if (response.success) {
          this.submittedEmail = email;
          this.emailSent = true;
        } else {
          this.errorMessage = response.message || 'Failed to send reset email. Please try again.';
        }
      },
      error: (error) => {
        this.loading = false;
        this.errorMessage = error.error?.message || 'An error occurred. Please try again.';
      }
    });
  }
} 